import clsx from 'clsx';
/** Brand count badge classes (tab counts, section titles); padding narrows as the digit count grows. */
export const getCountBadgeClassName = (count, className) => clsx('text-brand text-xs inline-flex items-center rounded-md bg-brand/10 py-0.5 font-semibold', count < 10 ? 'px-1.5' : count > 99 ? 'px-0.5' : 'px-1', className);
export const CountBadge = ({
  count,
  className,
  ...props
}) => <span className={getCountBadgeClassName(count, className)} {...props}>
        {count}
    </span>;